import { AdminPermission } from '../../../services/commons/Me';
import { AdminPermissions, AdminPermissionsOnModule } from '../../../services/commons/Permissions/AdminPermissions';
import { PermissionsAbilityHelper } from '../../../services/commons/Permissions/PermissionsAbilityHelper';

export interface UserPermissionsOnTeamsModule extends AdminPermissionsOnModule {
    readonly canAddUser?: boolean;
    readonly canRemoveUser?: boolean;
    readonly canEditDescription?: boolean;
}

export class TeamsPermissions {
    public static TEAMS_CODE = 'Teams';

    public static Admin: UserPermissionsOnTeamsModule = {};

    public static initializeTeamsAdminPermissions = (perms: Array<AdminPermission> = []) => {
        const permsOnTeams = AdminPermissions.filter(perms, TeamsPermissions.TEAMS_CODE);

        const canWrite: boolean = AdminPermissions.hasWritePermission(permsOnTeams);

        TeamsPermissions.Admin = {
            ...AdminPermissions.toAdminModulePermissions(permsOnTeams),
            canAddUser: canWrite,
            canRemoveUser: canWrite,
            canEditDescription: canWrite
        };
        PermissionsAbilityHelper.logPermissions('Teams', TeamsPermissions.Admin);
    };
}
